module.exports = __webpack_public_path__ + "img/careerLeave.b19922ee.png";